class BarWaitlist extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-bar-waitlist-dialog]');
    this.form = this.querySelector('[data-bar-waitlist-form]');
    this.status = this.querySelector('[data-bar-waitlist-status]');
    this.submitBtn = this.querySelector('.bar-waitlist__submit');

    this.querySelector('[data-bar-waitlist-open]').addEventListener('click', () => this.open());
    this.querySelector('[data-bar-waitlist-close]').addEventListener('click', () => this.close());
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.close();
    });
    this.form.addEventListener('submit', (event) => this.handleSubmit(event));

    /* En la PDP sigue la variante elegida: se muestra solo si esa variante está
       sin stock, y anota el acabado (ej. "Barra de Estáticos BÄR - Metal"). */
    if (this.hasAttribute('data-follow-variant') && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
    }
  }

  disconnectedCallback() {
    if (this.unsubscribeVariant) this.unsubscribeVariant();
  }

  onVariantChange(event) {
    if (!event || !event.data || event.data.sectionId !== this.dataset.sectionId) return;
    const variant = event.data.variant;
    this.hidden = Boolean(variant && variant.available);
    if (!variant) return;
    const title = variant.title && variant.title !== 'Default Title' ? `${this.dataset.baseTitle} - ${variant.title}` : this.dataset.baseTitle;
    this.dataset.productTitle = title;
    this.dataset.productUrl = `${this.dataset.baseUrl}?variant=${variant.id}`;
    const strong = this.querySelector('[data-bar-waitlist-product]');
    if (strong) strong.textContent = title;
  }

  open() {
    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }
  }

  close() {
    if (typeof this.dialog.close === 'function') {
      this.dialog.close();
    } else {
      this.dialog.removeAttribute('open');
    }
    window.setTimeout(() => {
      this.status.textContent = '';
      this.form.hidden = false;
      this.form.reset();
      this.submitBtn.disabled = false;
    }, 200);
  }

  /* Los mensajes llegan traducidos por data-attributes desde bar-waitlist.liquid:
     un asset .js no pasa por Liquid y no puede usar el filtro t. El segundo
     argumento es el fallback en español por si falta la clave. */
  text(key, fallback) {
    return this.dataset['i18n' + key.charAt(0).toUpperCase() + key.slice(1)] || fallback;
  }

  handleSubmit(event) {
    event.preventDefault();
    if (!this.form.reportValidity()) return;

    const webhookUrl = this.dataset.webhookUrl;
    if (!webhookUrl) {
      this.status.textContent = this.text('notConfigured', 'La lista de espera todavía no está configurada.');
      return;
    }

    const formData = new FormData(this.form);
    const payload = {
      nombre: formData.get('nombre').trim(),
      email: formData.get('email').trim(),
      telefono: formData.get('telefono').trim(),
      producto: this.dataset.productTitle,
      url: this.dataset.productUrl,
      fecha: new Date().toISOString(),
    };

    this.submitBtn.disabled = true;
    this.status.textContent = this.text('sending', 'Enviando...');

    fetch(webhookUrl, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload),
    })
      .then(() => {
        this.form.hidden = true;
        this.status.textContent = this.text('success', '¡Listo! Ya estás en la lista de espera. Te escribimos cuando sea tu turno.');
      })
      .catch(() => {
        this.status.textContent = this.text('error', 'Hubo un error. Probá de nuevo en un rato.');
        this.submitBtn.disabled = false;
      });
  }
}

customElements.define('bar-waitlist', BarWaitlist);
